// Landing-page attribution snapshot.
//
// Captured once at module load — i.e. before Vue Router has a chance to
// replace the URL — so campaign parameters survive even if the user's first
// in-app navigation drops the query string.
//
// Sent with every page view. The backend applies first-touch semantics
// (get_or_create), so re-sending is harmless and makes us resilient to the
// first request failing or arriving out of order.

const ATTRIBUTION_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'twclid', // X / Twitter Ads
  'fbclid', // Meta Ads
  'gclid', // Google Ads
];

function snapshot() {
  if (typeof window === 'undefined') {
    return { landingPath: '', referrer: '' };
  }

  let landingPath = '';
  try {
    const { pathname, search } = window.location;
    const params = new URLSearchParams(search);
    const kept = new URLSearchParams();

    ATTRIBUTION_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) kept.append(key, value);
    });

    const keptStr = kept.toString();
    landingPath = keptStr ? `${pathname}?${keptStr}` : pathname;
  } catch (_) {
    landingPath = '';
  }

  let referrer = '';
  try {
    // Ignore self-referrals so an internal reload doesn't overwrite the
    // original external source.
    if (document.referrer && !document.referrer.includes(window.location.host)) {
      referrer = document.referrer;
    }
  } catch (_) {
    referrer = '';
  }

  return { landingPath, referrer };
}

const LANDING = snapshot();

/** The landing path with only attribution params retained, e.g. `/?utm_source=x`. */
export function getLandingPath() {
  return LANDING.landingPath;
}

/** The external referrer captured at first load ('' for direct traffic). */
export function getLandingReferrer() {
  return LANDING.referrer;
}

/** True when the landing URL carried any campaign parameters. */
export function hasCampaignParams() {
  return LANDING.landingPath.includes('?');
}
